// The change card in the platform agent's panel (D5). Wording from the Amigo design's copy sheet (Card, Rejecting,
// Summary first, Row status, Applying, Done, Rejected, Replaced, Changed in the meantime, Partly failed).
export default {
  // A password the shop created on approval, shown once (contracts §4 `revealed`).
  secret: {
    show: 'Mostra password',
    hide: 'Nascondi password',
    copy: 'Copia',
    copied: 'Copiato',
    once: 'Mostrata solo ora. Copiala e conservala in un posto sicuro.',
  },
  loading: 'Caricamento della modifica…',
  load_failed: 'Impossibile caricare questa modifica.',
  load_retry: 'Riprova',
  // While the agent can't be reached, instead of the card's skeleton (QA119).
  load_waiting: {
    amigo: 'Questa modifica verrà mostrata qui quando Amigo sarà di nuovo disponibile. Non è cambiato nulla.',
    assistant:
      "Questa modifica verrà mostrata qui quando l'assistente sarà di nuovo disponibile. Non è cambiato nulla.",
  },
  // An approve that found the set approved already, in another tab or by the agent's follow-up (QA19).
  already_approved: "Questa modifica era già stata approvata, quindi non c'era nient'altro da fare.",
  action_failed: 'Operazione non riuscita, nulla è cambiato. Riprova tra un attimo.',
  removed: 'Rimosso',
  retry: 'Riprova',
  retry_one: 'Riprova {{name}}',
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Approvato.',
    retried: 'Riprovato.',
    rejected: 'Rifiutato.',
    // A restaurant skipped on a card with several restaurants (D18): its own set is rejected with this reason.
    skipped_restaurant: 'Sulla scheda è stato saltato.',
  },
  done: {
    summary_one: 'Fatto. {{count}} modifica applicata.',
    summary_other: 'Fatto. {{count}} modifiche applicate.',
    skipped_one: '{{count}} saltata, nulla è cambiato.',
    skipped_other: '{{count}} saltate, nulla è cambiato.',
  },
  partial: {
    summary_one: '{{applied}} di {{approved}} modifiche applicate. {{count}} non riuscite.',
    summary_other: '{{applied}} di {{approved}} modifiche applicate. {{count}} non riuscite.',
    detail_one: 'Le {{applied}} sono salvate. Nulla è cambiato per le {{count}} qui sotto.',
    detail_other: 'Le {{applied}} sono salvate. Nulla è cambiato per le {{count}} qui sotto.',
  },
  stale: {
    summary: '{{applied}} di {{approved}} modifiche applicate.',
    detail_one: '{{count}} è stata modificata da qualcun altro nel frattempo.',
    detail_other: '{{count}} sono state modificate da qualcun altro nel frattempo.',
    reason:
      "{{name}} l'ha cambiato in {{value}} alle {{time}}, prima della tua approvazione, quindi l'ho lasciato. Eccolo di nuovo dal nuovo valore:",
    decided_done:
      "{{name}} lo ha modificato in {{value}} alle {{time}}, prima della tua approvazione, quindi l'ho lasciato così. La sua nuova proposta è stata approvata sulla sua scheda.",
    decided_rejected:
      "{{name}} lo ha modificato in {{value}} alle {{time}}, prima della tua approvazione, quindi l'ho lasciato così. La sua nuova proposta è stata rifiutata.",
    decided_replaced:
      "{{name}} lo ha modificato in {{value}} alle {{time}}, prima della tua approvazione, quindi l'ho lasciato così. La sua nuova proposta è stata sostituita da una scheda più recente.",
    decided_expired:
      "{{name}} lo ha modificato in {{value}} alle {{time}}, prima della tua approvazione, quindi l'ho lasciato così. La sua nuova proposta è scaduta.",
  },
  undo_partly_one: '{{count}} di queste non possono essere annullate.',
  undo_partly_other: '{{count}} di queste non possono essere annullate.',
  undone: {
    summary_one: "Annullata. La {{count}} modifica è tornata com'era prima.",
    summary_other: "Annullate. Le {{count}} modifiche sono tornate com'erano prima.",
    detail: "L'annullamento è registrato anche nel log di Amigo e in Menu → Cronologia modifiche.",
    partly_summary: 'Annullate in parte. {{undone}} di {{count}} modifiche sono tornate come prima.',
    partly_changed_one: "{{count}} è stata modificata da qualcun altro nel frattempo, quindi resta com'è.",
    partly_changed_other: '{{count}} sono state modificate da qualcun altro nel frattempo, quindi restano come sono.',
    partly_kept_one: '{{count}} era già tornata come prima.',
    partly_kept_other: '{{count}} erano già tornate come prima.',
    partly_cannot_one: "{{count}} non può essere annullata, come un'eliminazione, quindi resta com'è.",
    partly_cannot_other: '{{count}} non possono essere annullate, come le eliminazioni, quindi restano come sono.',
    partly_left_one: "{{count}} resta com'è.",
    partly_left_other: '{{count}} restano come sono.',
  },
  summary: {
    group_one: '{{count}} piatto: {{reason}}',
    group_other: '{{count}} piatti: {{reason}}',
    group_names_more_one: '{{names}} e altri {{count}}',
    group_names_more_other: '{{names}} e altri {{count}}',
    average: '{{amount}} a piatto in media',
    needs_look: 'Da controllare',
    nothing_else: "Nient'altro cambia",
  },
  labels: {
    waiting: 'In attesa',
    skip: 'Salta',
    unskip: 'Annulla salto',
    approve_all: 'Approva tutto',
    approve_one: 'Approva {{count}}',
    approve_other: 'Approva {{count}}',
    approve_all_count_one: 'Approva tutti i {{count}}',
    approve_all_count_other: 'Approva tutti i {{count}}',
    approve_row: 'Approva',
    reject: 'Scarta',
    reject_confirm: 'Rifiuta',
    back: 'Indietro',
    why: {
      amigo: 'Perché no? (facoltativo, Amigo lo legge)',
      assistant: "Perché no? (facoltativo, l'assistente lo legge)",
    },
    hint: 'Oppure rispondi qui sotto per cambiare qualcosa.',
    show_all_one: 'Mostra tutte le {{count}} modifiche',
    show_all_other: 'Mostra tutte le {{count}} modifiche',
    show_less: 'Mostra meno',
    applying_one: 'Applicazione di {{count}} modifica…',
    applying_other: 'Applicazione di {{count}} modifiche…',
    high_impact: 'Alto impatto',
    done: 'Fatto',
    running: 'In corso',
    show_changes: 'Mostra modifiche',
    hide_changes: 'Nascondi modifiche',
    rows: {
      skipped: 'Saltato',
      applied: 'Applicato',
      failed: 'Non applicato',
      changed: 'Modificato nel frattempo',
      kept: 'Lasciato così',
    },
    history: {
      amigo: 'Apri nel log di Amigo',
      assistant: "Apri nel log dell'assistente",
    },
    undo: 'Annulla',
    to: 'a',
    from: 'da',
    rejected: 'Rifiutato',
    replaced: 'Sostituito',
    expired: 'Scaduto',
  },
};
